import React from 'react';
import * as PropTypes from 'prop-types';

import { Spacer } from './elements';

function Spa96(props) {
  return <Spacer className={props.className} />;
}

Spa96.propTypes = {
  className: PropTypes.string,
};

export default Spa96;
